//отправка text/image/video/file

import {
  useCallback,
  useState,
} from "react";

import {
  getAttachmentType,
  getImageDimensions,
  getVideoDimensions,
  uploadMatrixFile,
} from "../services/matrixMedia";


export default function useMatrixMessageSender(
  client,
  roomId
) {
  const [sending, setSending] =
    useState(false);

  const [uploading, setUploading] =
    useState(false);

  const [error, setError] =
    useState("");


  const clearError =
    useCallback(() => {
      setError("");
    }, []);


  const sendText =
    useCallback(
      async (text) => {
        if (
          !client ||
          !roomId ||
          !text?.trim()
        ) {
          return;
        }

        try {
          setSending(true);
          setError("");

          await client.sendMessage(
            roomId,
            {
              msgtype: "m.text",
              body: text.trim(),
            }
          );
        } catch (err) {
          console.error(
            "[CHAT] Text send error:",
            err
          );

          setError(
            err?.message ||
              "Не удалось отправить сообщение"
          );

          throw err;
        } finally {
          setSending(false);
        }
      },
      [client, roomId]
    );


  const sendImage =
    useCallback(
      async (
        file,
        mxcUrl
      ) => {
        const dimensions =
          await getImageDimensions(
            file
          );

        await client.sendMessage(
          roomId,
          {
            msgtype: "m.image",

            body: file.name,

            filename: file.name,

            url: mxcUrl,

            info: {
              mimetype:
                file.type,

              size:
                file.size,

              w:
                dimensions.width,

              h:
                dimensions.height,
            },
          }
        );
      },
      [client, roomId]
    );


  const sendVideo =
    useCallback(
      async (
        file,
        mxcUrl
      ) => {
        const dimensions =
          await getVideoDimensions(
            file
          );

        await client.sendMessage(
          roomId,
          {
            msgtype: "m.video",

            body: file.name,

            filename: file.name,

            url: mxcUrl,

            info: {
              mimetype:
                file.type,

              size:
                file.size,

              w:
                dimensions.width,

              h:
                dimensions.height,

              duration:
                dimensions.duration,
            },
          }
        );
      },
      [client, roomId]
    );


  const sendFile =
    useCallback(
      async (
        file,
        mxcUrl
      ) => {
        await client.sendMessage(
          roomId,
          {
            msgtype: "m.file",

            body: file.name,

            filename: file.name,

            url: mxcUrl,

            info: {
              mimetype:
                file.type ||
                "application/octet-stream",

              size:
                file.size,
            },
          }
        );
      },
      [client, roomId]
    );


  const sendFileMessage =
    useCallback(
      async (file) => {
        if (
          !client ||
          !roomId ||
          !file
        ) {
          return;
        }

        try {
          setUploading(true);
          setError("");

          const mxcUrl =
            await uploadMatrixFile(
              client,
              file
            );

          const type =
            getAttachmentType(
              file.type
            );

          if (
            type === "m.image"
          ) {
            await sendImage(
              file,
              mxcUrl
            );
          } else if (
            type === "m.video"
          ) {
            await sendVideo(
              file,
              mxcUrl
            );
          } else {
            await sendFile(
              file,
              mxcUrl
            );
          }
        } catch (err) {
          console.error(
            "[CHAT] File upload error:",
            err
          );

          setError(
            err?.message ||
              "Не удалось отправить файл"
          );

          throw err;
        } finally {
          setUploading(false);
        }
      },
      [
        client,
        roomId,
        sendImage,
        sendVideo,
        sendFile,
      ]
    );


  return {
    sending,
    uploading,
    error,

    sendText,
    sendFileMessage,

    clearError,
  };
}